import { AppWindow, Headset, ArrowRight } from "lucide-react";

const appSteps = [
  { n: "01", t: "Contratação", d: "Setup da conta e definição da estrutura da campanha." },
  { n: "02", t: "Treinamento", d: "Capacitação da equipe para operar a plataforma." },
  { n: "03", t: "Organização da base", d: "Importação, segmentação e enriquecimento de contatos." },
  { n: "04", t: "Operação da equipe", d: "Disparos, automações e acompanhamento interno." },
  { n: "05", t: "Relatórios e resultados", d: "Indicadores estratégicos para decisão da campanha." },
];

const serviceSteps = [
  { n: "01", t: "Diagnóstico estratégico", d: "Análise da campanha, base e objetivos eleitorais." },
  { n: "02", t: "Estruturação operacional", d: "Desenho do plano de comunicação e fluxos." },
  { n: "03", t: "Implantação", d: "Setup técnico, conexões e segmentações iniciais." },
  { n: "04", t: "Monitoramento", d: "Acompanhamento contínuo de performance e estabilidade." },
  { n: "05", t: "Otimização contínua", d: "Ajustes estratégicos e ganhos progressivos." },
];

const Flow = ({ icon: Icon, tag, title, msg, steps, dark }: any) => (
  <div className={`rounded-3xl p-8 lg:p-10 relative overflow-hidden ${
    dark ? "bg-gradient-cta text-primary-foreground border border-white/10 shadow-elegant" : "bg-card border border-border shadow-card"
  }`}>
    {dark && <div className="absolute inset-0 grid-bg opacity-20 pointer-events-none" />}
    <div className="relative">
      <div className="flex items-center gap-3 mb-6">
        <div className={`h-11 w-11 rounded-xl flex items-center justify-center ${
          dark ? "bg-white/15" : "bg-gradient-primary shadow-soft"
        }`}>
          <Icon className={`h-5 w-5 ${dark ? "text-highlight" : "text-primary-foreground"}`} />
        </div>
        <div className={`text-xs font-bold uppercase tracking-wider ${dark ? "text-highlight" : "text-accent"}`}>
          {tag}
        </div>
      </div>
      <h3 className="text-2xl lg:text-3xl font-bold leading-tight">{title}</h3>

      <ol className="mt-8 space-y-4">
        {steps.map((s: any) => (
          <li key={s.n} className="flex items-start gap-4">
            <div className={`h-10 w-10 shrink-0 rounded-xl flex items-center justify-center text-sm font-bold ${
              dark ? "bg-white/10 text-highlight border border-white/15" : "bg-muted text-primary border border-border"
            }`}>
              {s.n}
            </div>
            <div className="flex-1 pt-1">
              <div className={`font-bold ${dark ? "text-primary-foreground" : "text-foreground"}`}>{s.t}</div>
              <div className={`text-sm mt-0.5 ${dark ? "text-primary-foreground/75" : "text-muted-foreground"}`}>{s.d}</div>
            </div>
          </li>
        ))}
      </ol>

      <div className={`mt-8 pt-6 border-t flex items-center gap-2 text-sm font-semibold italic ${
        dark ? "border-white/15 text-highlight" : "border-border text-accent"
      }`}>
        <ArrowRight className="h-4 w-4" /> {msg}
      </div>
    </div>
  </div>
);

export function ComoFuncionaSection() {
  return (
    <section id="como-funciona" className="py-24 bg-background">
      <div className="mx-auto max-w-7xl px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/10 text-accent text-xs font-semibold uppercase tracking-wider">
            Como funciona
          </div>
          <h2 className="mt-4 text-4xl sm:text-5xl font-bold text-foreground">
            Dois caminhos.{" "}
            <span className="bg-gradient-primary bg-clip-text text-transparent">Uma operação política de alto nível.</span>
          </h2>
        </div>

        <div className="mt-14 grid lg:grid-cols-2 gap-6 items-start">
          <Flow
            icon={AppWindow}
            tag="Vox App"
            title="O fluxo da operação interna."
            msg="Sua equipe opera com autonomia e inteligência."
            steps={appSteps}
          />
          <Flow
            icon={Headset}
            tag="Vox Service"
            title="O fluxo da operação assistida."
            msg="Nós acompanhamos sua campanha durante toda a operação."
            steps={serviceSteps}
            dark
          />
        </div>
      </div>
    </section>
  );
}
